/** Minimal add-on row shape from `GET package/add-ons-by-location/:id`. */
export interface AddOnPackageLike {
  id?: string;
  package_name?: string;
  variants?: any[];
  [key: string]: any;
}

/** True when a cached/API row looks like a real add-on package (not a wrapper object). */
export function isValidAddOnPackageRow(row: any): row is AddOnPackageLike {
  if (!row || typeof row !== 'object' || Array.isArray(row)) {
    return false;
  }
  const r = row as AddOnPackageLike;
  const id = String(r.id ?? '').trim();
  const name = String(r.package_name ?? '').trim();
  return !!id || !!name;
}

/** True when every cached entry is a valid add-on package row. */
export function isValidAddOnPackagesCache(rows: any[] | null | undefined): rows is AddOnPackageLike[] {
  return Array.isArray(rows) && rows.length > 0 && rows.every(isValidAddOnPackageRow);
}

/**
 * Normalize `GET package/add-ons-by-location/:id` `data` to a flat package array.
 * Supports direct array, `{ packages }`, `{ items }`, or a single package object.
 */
export function normalizeAddOnPackagesResponse<T extends AddOnPackageLike = AddOnPackageLike>(
  data: any
): T[] {
  if (Array.isArray(data)) {
    return data as T[];
  }
  if (data && typeof data === 'object') {
    const obj = data as { packages?: any; items?: any };
    if (Array.isArray(obj.packages)) {
      return obj.packages as T[];
    }
    if (Array.isArray(obj.items)) {
      return obj.items as T[];
    }
    if (isValidAddOnPackageRow(data)) {
      return [data as T];
    }
  }
  return [];
}
